import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ReportDataInstance } from "@/lib/DataPort";
import { useUserCreate } from "@/store/User";
import classNames from "classnames";
import { useTranslations } from "next-intl";
import { useShallow } from "zustand/react/shallow";
import styles from "./index.module.scss";
import { NewBaseIcon } from "../NewBaseIcon";
import DES_IMG from "./assets/des.png";
import RIGHT_ARROW from "./assets/right_arrow.svg?raw";
import Image from "next/image";
const handleOpen = params => {
  var _window_location, _window, _document, _window_open, _window1;
  ReportDataInstance.reportShareBtn({
    user_id: params === null || params === void 0 ? void 0 : params.user_id
  });
  // 吊起客户端等
  // const url = extractBaseUrl(window.location.href);
  const url = "a1.art";
  const open_url = (_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : _window_location.href;
  const entrance_url = (_document = document) === null || _document === void 0 ? void 0 : _document.referrer;
  // const entrance_url = "https://www.google.com/";
  const _url = "intent://".concat(url, "#Intent;scheme=https;package=art.a1.twa;S.browser_fallback_url=https://play.google.com/store/apps/details?id=art.a1.twa&referrer=utm_source%3Dh5,open_url%3D").concat(open_url, ",entrance_url%3D").concat(entrance_url, ";end");
  (_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_open = _window1.open) === null || _window_open === void 0 ? void 0 : _window_open.call(_window1, _url);
};
const SharePanel = () => {
  const t = useTranslations();
  const {
    userInfo
  } = useUserCreate(useShallow(state => ({
    userInfo: state.userState
  })));
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(styles.install_guide_container, styles.install_guide_container_android),
    style: {
      zIndex: 1000
    },
    onClick: () => {
      handleOpen({
        user_id: userInfo.userId
      });
    },
    children: [/*#__PURE__*/_jsx("span", {
      children: "\uD83D\uDD1E"
    }), /*#__PURE__*/_jsx("span", {
      className: styles.mainText,
      children: t("Install_Guide_Android_Text")
    }), /*#__PURE__*/_jsx(Image, {
      src: DES_IMG,
      alt: "img"
    }), /*#__PURE__*/_jsx("div", {
      className: styles.right_arrow,
      children: /*#__PURE__*/_jsx(NewBaseIcon, {
        icon: RIGHT_ARROW
      })
    })]
  });
};
export default SharePanel;